import { api } from "@/lib/api";

export const directoryApi = {
    topCategories: () => api.get("/directory/categories").then((r) => r.data.items),
    categoryDetail: (id) => api.get(`/directory/categories/${id}`).then((r) => r.data),
    providersForCategory: (l2Id) =>
        api.get(`/directory/categories/${l2Id}/providers`).then((r) => r.data),
    providerDetail: (id) => api.get(`/directory/providers/${id}`).then((r) => r.data),
    search: (q) => api.get("/directory/search", { params: { q } }).then((r) => r.data),
};

export const membersApi = {
    me: () => api.get("/members/me").then((r) => r.data),
    patchIdentity: (data) => api.patch("/members/me/identity", data).then((r) => r.data),
    submitPaymentReference: (payment_reference) =>
        api.patch("/members/me/payment-reference", { payment_reference }).then((r) => r.data),
    getInterests: () => api.get("/members/me/interests").then((r) => r.data),
    setInterests: (category_ids) =>
        api.put("/members/me/interests", { category_ids }).then((r) => r.data),
    listOffers: (params = {}) =>
        api.get("/members/offers", { params }).then((r) => r.data),
    getOffer: (offer_id) =>
        api.get(`/members/offers/${offer_id}`).then((r) => r.data),
    claimOffer: (offer_id, location_id = null) =>
        api.post(`/members/offers/${offer_id}/claim`, { location_id }).then((r) => r.data),
    listClaims: () => api.get("/members/me/claims").then((r) => r.data),
    cancelClaim: (claim_id) =>
        api.delete(`/members/me/claims/${claim_id}`).then((r) => r.data),
};
